
import { Component,Prop, BaseMixins } from '@/lib';
import Hicon from '@/components/hicon/hicon.vue'
import './custom-bread-crumb.less'

@Component({
    components:{Hicon}
})
export default class CustomBreadCrumb extends BaseMixins {
    name:string='CustomBreadCrumb';
    @Prop({type:Boolean,default:false}) showIcon:boolean;
    @Prop({type:Array,default: function() { return []; }}) list:Array<any>;
    @Prop({type:Number,default:14}) fontSize:number;

    showTitle (item) {
      return this.L(item.meta.title)
    }

    isCustomIcon (iconName) {
      return iconName.indexOf('_') === 0
    }
    
    getCustomIconName (iconName) {
      return iconName.slice(1)
    }
}

